<script>
import jsonp from 'jsonp'
import { useReturnUrl } from '@/hooks'
import { __WX_BIND_USER__ } from '@/utils/enum'

export default {
  name: 'BindResult',
  props: {
    type: String,
    default: ''
  },
  data() {
    return {
      timerCount: 5,
      bindFailReason: '',
      userBindInfo: {}
    }
  },
  computed: {
    finish({ type }) {
      return type && type === 'success'
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
    window.sessionStorage.clear()
  },
  beforeMount() {
    const bindInfo = window.sessionStorage.getItem(__WX_BIND_USER__)
    if (bindInfo) {
      try {
        this.userBindInfo = JSON.parse(bindInfo)
      } catch (e) {
        this.userBindInfo = {}
      }
      this.bindFailReason = this.userBindInfo.bindFailReason
    }
  },
  mounted() {
    if (!this.finish) return
    this.timer = setInterval(() => {
      this.timerCount--
      if (this.timerCount === 0) {
        clearInterval(this.timer)
        const { returnUrl } = useReturnUrl()
        top.location.href = decodeURIComponent(returnUrl)
      }
    }, 1000)
  },
  methods: {
    reBind() {
      jsonp(`//login.jdcloud.com/logout`)
      const { returnUrl } = useReturnUrl()
      top.location.href = `//login.jdcloud.com?returnUrl=${returnUrl}`
    }
  }
}
</script>

<template>
  <div>
    <div class="bind-result-container">
      <div class="bind-result-content">
        <div class="bind-result-title">绑定已有账号</div>
        <div class="bind-info">
          <i v-if="finish" class="el-icon-success icon success" />
          <i v-else class="el-icon-error icon brand-color" />
          <p class="result-tip">
            {{ finish ? '绑定成功' : '绑定失败' }}
          </p>
          <p class="result-tip-content">
            <template v-if="finish">
              您的微信已与京东云账号「<span class="brand-color">{{
                userBindInfo.loginName || '--'
              }}</span
              >」绑定，可微信扫码一键登录京东云
            </template>
            <span v-else> {{ bindFailReason }} </span>
          </p>
          <p class="result-tip-footer">
            <template v-if="finish">
              <span class="brand-color">{{ timerCount }}</span>
              秒后自动返回
            </template>
            <el-button style="width: 360px; height: 40px" v-else type="danger" @click="reBind"
              >重新绑定</el-button
            >
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.bind-result-container {
  margin: 0 auto;
  width: 1200px;
  height: 544px;
  margin-top: 16px;
  background-color: #fff;
  .bind-result-content {
    padding: 24px;
    .bind-result-title {
      font-size: 24px;
      font-weight: 400;
      display: flex;
      justify-content: center;
      padding-bottom: 24px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    }
    .bind-info {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      margin-top: 40px;
      .result-tip {
        margin-bottom: 8px;
        font-size: 20px;
        font-weight: 600;
      }
      .result-tip-content {
        font-size: 14px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.65);
      }
      .result-tip-footer {
        margin-top: 24px;
        font-size: 14px;
        font-weight: 400;
      }
      .icon {
        font-size: 45px;
        margin-bottom: 24px;
      }
      .success {
        color: #1bca69;
      }
      .brand-color {
        color: rgba(225, 37, 27, 1);
      }
    }
  }
}
</style>
